export * from './inventoryTable'
